// Components
import initMap from './components/events/map';
import initEventsFilter from './components/events/filter';
import initEventsView from './components/events/view';

const eventsFilter = document.querySelector('.js-event-filter');
const mapEl = document.querySelector('.js-map');

// Filters are initialised in initMap function
// If no map element, init filters alone
if (mapEl) {
    initMap(mapEl);
} else if (eventsFilter) {
    initEventsFilter(eventsFilter);
}

const eventsView = document.querySelector('.js-event-view');

if (eventsView) {
    initEventsView(eventsView);
}
